<template>
<!-- 城市-汇付账户-创建汇付账户 -->
    <el-dialog :visible.sync="show" width="600px" append-to-body :before-close="closeDialog">
        <el-form ref="form" :model="submit_data" :rules="rules" label-width="80px">
            <el-form-item label="手机号:" label-width="120px" prop="phone">
                <el-input v-model="submit_data.phone" placeholder="请输入手机号" style="width: 60%" type="tel"> </el-input>
            </el-form-item>
        </el-form>

        <!-- 对话框底部按钮 -->
        <div style="display: flex; justify-content: center">
            <el-button type="primary" @click="createAccount">确定</el-button>
            <el-button @click="closeDialog">关闭</el-button>
        </div>
    </el-dialog>
</template>
<script>
var _this;

export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newDate, oldData) {
            _this.show = true;
        }
    },
    data() {
        return {
            show: false,
            submit_url: '/huifu/merchantUrlForward',

            submit_data: {
                phone: ''
            },
            rules: {
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
                ]
            }
        };
    },
    created() {
        _this = this;
    },

    methods: {
        // 提交
        onSubmitDig() {
            _this.$emit('onSubmit');
            _this.closeDialog();
        },
        createAccount() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    _this.$post(_this.submit_url, _this.submit_data).then(res => {
                        if (res.code == 200) {
                            if (res.data.url) {
                                window.open(res.data.url);
                                _this.closeDialog();
                            } else {
                                _this.closeDialog();
                            }
                        } else {
                            _this.$message({
                                message: res.msg,
                                type: 'error'
                            });
                        }
                    });
                }
            });
        },

        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.submit_data = {
                phone: ''
            };
            this.$refs.form.clearValidate();
        }
    }
};
</script>
<style scoped>

</style>